import { LegalPageShell, legalStyles as s } from '../components/LegalPageShell';

export function ContactPage() {
  return (
    <LegalPageShell title="Contact Us">
      <section>
        <p>
          For support, business inquiries, subscriptions, or technical assistance, please contact the BidMaster Support
          Team using the details below.
        </p>
      </section>

      <section className="rounded-2xl border border-slate-200 bg-slate-50/80 p-8 space-y-6">
        <div>
          <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-2">Email</h2>
          <p>
            <a href="mailto:support@bidmaster.co.in" className={s.link}>
              support@bidmaster.co.in
            </a>
          </p>
        </div>

        <div>
          <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-2">Website</h2>
          <p>
            <a href="https://www.bidmaster.co.in" className={s.link} target="_blank" rel="noopener noreferrer">
              www.bidmaster.co.in
            </a>
          </p>
        </div>

        <div>
          <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-2">Business hours</h2>
          <p>9:00 AM – 6:00 PM (IST), Monday to Saturday</p>
        </div>
      </section>

      <section>
        <p>
          We aim to respond to all inquiries within 24–48 business hours. For subscription, refund, or billing requests,
          please include your registered email address and any relevant transaction details.
        </p>
      </section>
    </LegalPageShell>
  );
}
